<template>
    <v-content>
        <v-container>
            <v-card>
                <v-card-title>
                    <v-icon>notifications</v-icon> Notificaciones:
                    <v-spacer/>
                    <v-text-field
                            v-model="search"
                            append-icon="search"
                            label="Buscar"
                            single-line
                            hide-details
                    />
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :items="notifications"
                        :items-per-page="5"
                        :search="search"
                        class="elevation-1"
                        ref="table"
                >
                    <template v-slot:item.actions="{ item }">
                        <v-icon @click="readNotification(item.id)" :color="item.read ? 'primary' : ''">fa-check</v-icon>
                    </template>

                    <template v-slot:item.transmitter="{ item }">
                        {{item.transmitter.first_name + ' ' + item.transmitter.last_name}}
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
    </v-content>
</template>

<script>
    import { mapState } from 'vuex'
    import {db} from "../plugins/db";

    export default {
        name: "Notifications",
        data(){
            return{
                search:'',
                headers: [
                    {
                        text: 'Emisor',
                        align: 'left',
                        sortable: true,
                        value: 'transmitter',
                    },
                    { text: 'Mensaje', value: 'body' },
                    { text: '¿Leido?', value: 'actions' }


                ],
            }
        },
        computed:{
            ...mapState({
                notifications:state => state.notification.notifications
            })
        },
        methods:{
            readNotification(id){
                db.collection('notifications').doc(id).update( {read:true})
            }
        }
    }
</script>

<style scoped>

</style>